import React from 'react';

const ProfileInformationSkeleton = () => {
  return (
    <div
      className='rounded-lg p-6 flex flex-col md:flex-row items-start md:items-center gap-6'
      style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
    >
      <div
        className='skeleton h-20 w-20 rounded-lg shrink-0'
      />

      <div className='flex-grow'>
        <div className='skeleton h-7 rounded w-44 mb-2' />
        <div className='skeleton h-4 rounded w-80 max-w-full mb-3' />
        <div className='space-y-2 mb-3 max-w-3xl'>
          <div className='skeleton h-3.5 rounded w-full' />
          <div className='skeleton h-3.5 rounded w-3/4' />
        </div>
        <div className='mt-2 flex flex-wrap gap-2'>
          <div className='skeleton h-6 rounded-md w-24' />
          <div className='skeleton h-6 rounded-md w-20' />
        </div>
      </div>
    </div>
  );
};

export default ProfileInformationSkeleton;
